export const SubItemCard = styled.div`
  margin-top: 16px;
  position: relative;
`;

export const DeleteButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
`;
import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  min-width: 500px;
  max-width: 600px;
`;

export const ModalTitle = styled.h3`
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
`;

export const ItemTypesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 24px;
`;

export const ItemTypeButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 120px;
  text-align: center;
  &:hover {
    border-color: #007bff;
    background-color: #f8f9fa;
  }
`;

export const ItemTypeIcon = styled.div`
  margin-bottom: 12px;
  color: #007bff;
`;

export const ItemTypeTitle = styled.h4`
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: bold;
  color: #333;
`;

export const ItemTypeDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

export const Summary = styled.div`
  display: flex;
  gap: 32px;
`;

export const SummaryItem = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
`;

export const SummaryLabel = styled.span`
  font-family: 'Inter', sans-serif;
  color: #696969;
  white-space: nowrap;
`;

export const SummaryValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  flex: 1;
`;

export const ActionsDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  position: relative;
  z-index: 5;
`;

export const DeleteDiv = styled.div<{ $disabled?: boolean }>`
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  cursor: pointer;
  color: #F87171;
  
  &:hover {
    background-color: #fee2e2;
  }

  ${({ $disabled }) => $disabled && `
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  `}
`;

export const ItemLockFieldset = styled.fieldset<{ $locked?: boolean }>`
  border: none;
  padding: 0;
  margin: 0;
  min-width: 0;

  ${({ $locked }) => $locked && `
    opacity: 0.6;
    pointer-events: none;
  `}
`;

export const InvoicedItemNotice = styled.div`
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #F59E0B;
  background-color: #FFFBEB;
  color: #92400E;
  font-size: 14px;
  font-weight: 600;
`;

export const CollapsibleItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 12px 0;
`;

export const ItemNumber = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #303030;
`;

export const ToggleButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0090D3;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
`;

export const SaveIcon = styled.div<{ $isSaved: boolean }>`
  display: ${({ $isSaved }) => $isSaved ? 'flex' : 'none'};
  align-items: center;
  color: #28a745;
  margin-left: auto;
  margin-right: 5px;
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 20px;
`;